import { BaseConfig } from '../internals/config';
import { slugError } from '../internals/errors/errors';
export class ShopConfig extends BaseConfig {
    constructor(config) {
        super(config);
        /**
         *  If it is a config instance.
         */
        this._isConfigInstance = true;
        if (config._isConfigInstance) {
            return config;
        }
        this._setReservator(config.reservator);
        this._setDefaultReservationTime(config.defaultReservationTime);
    }
    /**
     *  Set thee reservator settings. Checks if the input is valid and
     *  chooses sensible defaults if no input is given.
     */
    _setReservator(reservator) {
        if (!reservator) {
            reservator = {};
        }
        // noinspection SuspiciousTypeOfGuard
        if (reservator.maxPendingReservations && typeof reservator.maxPendingReservations !== 'number') {
            throw slugError('reservator.maxPendingReservations is not a number', ['shop', 'config', 'error', 'maxPendingReservations']);
        }
        // noinspection SuspiciousTypeOfGuard
        if (reservator.maxConcurrentReservations && typeof reservator.maxConcurrentReservations !== 'number') {
            throw slugError('reservator.maxConcurrentReservations is not a number', ['shop', 'config', 'error', 'maxConcurrentReservations']);
        }
        if (!reservator.maxPendingReservations) {
            reservator.maxPendingReservations = 20;
        }
        if (!reservator.maxConcurrentReservations) {
            // Max concurrent reservations will default to 1, similar to 'in sync'.
            reservator.maxConcurrentReservations = 1;
        }
        this.reservator = reservator;
    }
    /**
     *  Set the default reservation time, Checks if the input is valid and
     *  chooses a sensible default if no input is given.
     */
    _setDefaultReservationTime(defaultReservationTime) {
        // noinspection SuspiciousTypeOfGuard
        if (defaultReservationTime && typeof defaultReservationTime !== 'number') {
            throw slugError('defaultReservationTime is not a number', ['shop', 'config', 'error', 'defaultReservationTime']);
        }
        if (!defaultReservationTime) {
            defaultReservationTime = 8;
        }
        this.defaultReservationTime = defaultReservationTime;
    }
}
//# sourceMappingURL=config.js.map